export default __webpack_public_path__ + "static/media/bg.3d710f41.png";